export const styles = {
  form: { minWidth: '600px' }
}
